export default "__VITE_ASSET__BEbud_9R__"